import { getCurrentTenantId } from '@/utils/tenantUtils';

/**
 * Google OAuth credentials interface
 */
export interface GoogleOAuthCredentials {
  clientId: string;
  clientSecret: string;
}

/**
 * Get Google OAuth credentials - using Joules credentials for all tenants
 * This unifies the OAuth system across all tenants as per email integration unification plan
 */
export const getGoogleOAuthCredentials = async (): Promise<GoogleOAuthCredentials> => {
  const tenantId = await getCurrentTenantId();
  
  // Use Joules credentials for all tenants (unified OAuth system)
  const clientId = import.meta.env.VITE_JOULES_GOOGLE_CLIENT_ID;
  const clientSecret = import.meta.env.VITE_JOULES_GOOGLE_CLIENT_SECRET;
  
  if (!clientId || !clientSecret) {
    throw new Error('Joules Google OAuth credentials not configured. Please check VITE_JOULES_GOOGLE_CLIENT_ID and VITE_JOULES_GOOGLE_CLIENT_SECRET environment variables.');
  }
  
  return { clientId, clientSecret };
};

/**
 * Get Google OAuth credentials synchronously - using Joules credentials for all tenants
 * This unifies the OAuth system across all tenants as per email integration unification plan
 * @param isSolerroTenant - Whether this is the Solerro tenant (parameter kept for compatibility but not used)
 */
export const getGoogleOAuthCredentialsSync = (isSolerroTenant: boolean): GoogleOAuthCredentials => {
  // Use Joules credentials for all tenants (unified OAuth system)
  const clientId = import.meta.env.VITE_JOULES_GOOGLE_CLIENT_ID;
  const clientSecret = import.meta.env.VITE_JOULES_GOOGLE_CLIENT_SECRET;
  
  if (!clientId || !clientSecret) {
    throw new Error('Joules Google OAuth credentials not configured.');
  }
  
  return { clientId, clientSecret };
};